<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 669.12 471.3"
  >
    <polygon points="334.56 471.3 443.28 282.32 488.42 410.31 451.98 410.31 451.98 466.64 669.12 466.64 669.12 410.31 627.68 410.31 471.69 0 334.56 252.63 197.43 0 41.45 410.31 0 410.31 0 466.64 217.15 466.64 217.15 410.31 180.7 410.31 225.84 282.32 334.56 471.3"></polygon>
  </svg>
</template>
